import { Link, useLocation } from 'react-router-dom';

function Breadcrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  if (pathnames.length === 0) return null;

  const nameMap: Record<string, string> = {
    category: '分类',
    article: '文章',
    about: '关于我们',
    'skin-care': '肌肤护理',
    'image-enhance': '形象提升',
    'beauty-secrets': '美丽秘籍',
    'mom-stories': '妈妈故事',
  };

  const breadcrumbItems = [
    { name: '首页', path: '/' },
    ...pathnames.map((name, index) => {
      const path = `/${pathnames.slice(0, index + 1).join('/')}`;
      let displayName = nameMap[name] || decodeURIComponent(name);
      displayName = displayName.length > 20 ? displayName.slice(0, 20) + '...' : displayName;
      return { name: displayName, path };
    }),
  ];

  return (
    <nav aria-label="面包屑导航" className="w-full bg-background-50 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-2.5">
        <ol className="flex items-center flex-wrap gap-1 text-xs md:text-sm">
          {breadcrumbItems.map((item, index) => (
            <li key={item.path} className="flex items-center">
              {index > 0 && (
                <span className="mx-1.5 text-foreground-400" aria-hidden="true">
                  <i className="ri-arrow-right-s-line"></i>
                </span>
              )}
              {index === breadcrumbItems.length - 1 ? (
                <span className="text-foreground-600 font-medium">{item.name}</span>
              ) : (
                <Link
                  to={item.path}
                  className="text-foreground-400 hover:text-primary-500 transition-colors duration-200"
                >
                  {item.name}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}

export default Breadcrumb;